'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/naming-convention */

import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useRouter } from 'next/navigation'

import { pageEvent, trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { useEnvVariablesClientConfig } from '@context/EnvClientContext/EnvVariablesClientContext'

import { segmentEventCommonPropFuncAckoDrive } from '@utils/segmentProperties'
import { getConfig } from '@configs/evnConfig'

import { SearchProps } from './search-types'
// SearchDatalayerAttributes
import searchService from './search-service'

import { SearchItem, SearchResponse } from './search-response'
import SearchResults from './search-results'

import { Input } from '../../../Inputs/InputsV2'

// import eventTrackerService, { EventType } from '@/Services/eventTracker'

const SearchInputWrapper = styled.div<{ isMobile; widthValue }>`
  width: ${props => props.widthValue || '100%'};
  position: relative;
  background-color: #ffffff;
  ${props =>
    props.isMobile &&
    `
      margin: 0 20px;
      padding: 16px 0;
      width: auto;
    `};
`

const Search = (props: SearchProps) => {
  const { isMobile, onBackAction, width } = props

  const [searchQuery, setSearchQuery] = useState<string>('')
  const [searchResponse, setSearchRespone] = useState<SearchResponse>(undefined)
  const isSearchModal = !!onBackAction
  const router = useRouter()

  const config = useEnvVariablesClientConfig()
  const currentEnv = config?.ACKO_ENV
  const ACKO_DRIVE_ENDPOINT = getConfig(currentEnv)?.ackoDriveEndpoint

  const handleInputs = e => {
    setSearchQuery(e?.target?.value?.trimStart())
  }

  const searchApiCall = async trimmedSearchQuery => {
    const searchResponse = await searchService.getSearchResponse(trimmedSearchQuery, ACKO_DRIVE_ENDPOINT)
    setSearchRespone(searchResponse)
  }

  useEffect(() => {
    const trimmedSearchQuery = searchQuery.trim()
    if (trimmedSearchQuery.length >= 3) {
      searchApiCall(trimmedSearchQuery)
    } else {
      setSearchRespone(undefined)
    }
  }, [searchQuery])

  const onClose = () => {
    setSearchQuery('')
    setSearchRespone(undefined)
  }

  const closeSearchModal = () => {
    if (onBackAction) {
      onBackAction()
    }
  }

  const onShowAllByBrandClick = () => {
    sendGTMEventOnShowAll()
    setSearchQuery('')
    closeSearchModal()
    setSearchRespone(undefined)
    router.push(`/collection/${searchResponse.show_more_collection_name}/`)
  }

  const sendGTMEventOnShowAll = () => {
    const searchDatalayerAttributes = {
      search_query: searchQuery,
      search_navigation: searchResponse.show_more_brand_name,
    }

    const search_result1 = searchResponse.data[0]?.display_name
    const search_result2 = searchResponse.data[1]?.display_name
    const search_result3 = searchResponse.data[2]?.display_name
    const eventProperties = segmentEventCommonPropFuncAckoDrive({ pageType: '' })
    trackEvent('tap_btn_show_all_results', {
      ...eventProperties,
      search_datalayer_attributes: {
        ...searchDatalayerAttributes,
        collection_name: searchResponse.show_more_collection_name.replace(/-/g, '_'),
      },
      all_results: { search_result1, search_result2, search_result3 },
    })
  }

  const onSearchResultClick = (variant: SearchItem) => {
    const searchDatalayerAttributes = {
      search_query: searchQuery,
      search_navigation: variant.slug,
    }
    const eventProperties = segmentEventCommonPropFuncAckoDrive({ pageType: '' })
    trackEvent('tap_btn_search_variant_details', {
      ...eventProperties,
      search_datalayer_attributes: searchDatalayerAttributes,
    })

    closeSearchModal()
  }

  useEffect(() => {
    if (searchResponse?.success && searchResponse?.success !== 'False' && searchResponse.data.length <= 0) {
      const searchDatalayerAttributes = {
        search_query: searchQuery,
        search_navigation: '',
      }
      const search_query = searchDatalayerAttributes.search_query
      pageEvent('view_no_search_results', {
        search_query,
      })
    }
  }, [searchResponse])

  return (
    <SearchInputWrapper isMobile={isMobile} widthValue={width}>
      <Input
        isMobile={isMobile}
        iconType={isSearchModal ? 'back' : 'search'}
        iconClick={isSearchModal ? onBackAction : undefined}
        type="text"
        placeholder="Search all cars"
        name="search"
        value={searchQuery}
        handleInputs={handleInputs}
        label=""
        hideLabel
        showCloseIcon
        onCloseAction={onClose}
        width="100%"
        mWidth="100%"
        onClickProps={() => {
          //   eventTrackerService.pushEvent('tap_btn_search', EventType.TRACK_EVENT)
          const eventProperties = segmentEventCommonPropFuncAckoDrive({ pageType: '' })
          trackEvent('tap_btn_search', {
            ...eventProperties,
          })
        }}
      />
      {searchResponse && (
        <div data-testid="searchresults">
          <SearchResults
            searchResponse={searchResponse}
            onShowAllByBrandClick={onShowAllByBrandClick}
            onSearchResultClick={onSearchResultClick}
            isMobile={isMobile}
            isSearchModal={isSearchModal}
          />
        </div>
      )}
    </SearchInputWrapper>
  )
}

export default Search
